import FormComponent from "./form-component";
import Input, { FormParams } from "./input";

export default function DateInput(params: FormParams) {
  return (
    <FormComponent
      id={params.id}
      label={params.label}
      className={params.className}
    >
      <Input type="date" {...params} />
    </FormComponent>
  );
}
